export default __webpack_public_path__ + "static/media/arrow-left.49acc2f2.svg";